import { accordionClasses, accordionSummaryClasses, type Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const ContentWrapperStyle: StyleExtend<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  padding: '1rem',
  backgroundColor: (theme) => theme.palette.customColors.lightBeige,
  color: (theme) => theme.palette.customColors.gunMetal,
  borderRadius: '.25rem',
};

export const AccordionStyle: StyleExtend<Theme> = {
  margin: '0',
  backgroundColor: 'transparent !important',
  boxShadow: 'none',

  [`&.${accordionClasses.expanded}`]: {
    marginTop: '0',
  },
};

export const AccordionSummaryStyle: StyleExtend<Theme> = {
  padding: '0',

  [`&.${accordionSummaryClasses.expanded}`]: {
    minHeight: 'unset',
  },

  [`&.${accordionSummaryClasses.disabled}`]: {
    opacity: '1',
  },

  [`.${accordionSummaryClasses.content}`]: {
    paddingBlock: '1rem',
    margin: '0',
    display: 'flex',
    gap: '.75rem',
    alignItems: 'center',

    [`&.${accordionSummaryClasses.expanded}`]: {
      margin: '0',
    },
  },

  [`.${accordionSummaryClasses.expandIconWrapper}`]: {
    rotate: '180deg',
  },
};

export const AccordionDetailsStyle: StyleExtend<Theme> = {
  padding: '0',
};

export const ListStyle: StyleExtend<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '.5rem',
  padding: '0',
  listStyle: 'disc',
};

export const ListItemStyle: StyleExtend<Theme> = {
  display: 'list-item',
  padding: '0',
  paddingRight: '1rem',
  marginLeft: '1rem',

  '&::marker': {
    color: (theme) => theme.palette.customColors.copper,
    fontSize: '1rem',
  },
};
